import { DatePicker, Form, Modal, message } from 'antd';
import { omsOrderRecycleOrderUpdateTimes } from 'apis/oms';
import i18n from '../../../i18n';
import LOCALS from '../../../commons/locals';
import { useEffect, useMemo } from 'react';
import { OmsRecycleOrderDetail } from 'types/oms';
import {
  MODIFY_RECYCLE_ORDER_TIME_FIELDS,
  buildModifyRecycleOrderTimesPayload,
  getModifyRecycleOrderTimesInitialValues,
} from './modify-base-info.utils';

type Props = {
  open: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  data: OmsRecycleOrderDetail;
};

const ModifyTimes = ({ open, onCancel, onSuccess, data }: Props) => {
  const [form] = Form.useForm();
  const initialValues = useMemo(
    () => getModifyRecycleOrderTimesInitialValues(data),
    [data],
  );
  const editableFields = useMemo(
    () =>
      MODIFY_RECYCLE_ORDER_TIME_FIELDS.filter(
        (field) => initialValues[field.name],
      ),
    [initialValues],
  );

  useEffect(() => {
    if (open && data) {
      form.setFieldsValue(initialValues);
    }
  }, [open, data, form, initialValues]);

  const handleOk = async () => {
    const values = await form.validateFields();
    const omsRecycleOrderId = data.omsRecycleOrder?.id;
    if (!omsRecycleOrderId) return;

    const payload = buildModifyRecycleOrderTimesPayload(
      values,
      String(omsRecycleOrderId),
      initialValues,
    );

    if (Object.keys(payload).length <= 1) {
      onCancel();
      return;
    }

    await omsOrderRecycleOrderUpdateTimes(payload);

    message.success(i18n.t(LOCALS.successful_operation));
    onSuccess();
  };

  return (
    <Modal
      open={open}
      title={i18n.t(LOCALS.modify_order_times)}
      onCancel={onCancel}
      onOk={handleOk}
      destroyOnClose
      width={560}
      styles={{ body: { maxHeight: '70vh', overflowY: 'auto' } }}
    >
      <Form form={form} layout="vertical" className="mt-4">
        {editableFields.map((field) => (
          <Form.Item
            key={field.name}
            name={field.name}
            label={i18n.t(field.labelKey)}
          >
            <DatePicker
              showTime={{ format: 'HH:mm' }}
              format="YYYY-MM-DD HH:mm"
              className="w-full"
              allowClear={false}
            />
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};

export default ModifyTimes;
